import React from 'react'
import LinkButton from './LinkButton'
import RemarkImage from './RemarkImage'
import Img from 'gatsby-image'

export default ({ title, description, to, src, fluid, tags }) => {
  return (
    <article className="flex flex-col sm:flex-row mt-8 p-4 border-b-8 border-theme">
      <div className="h-full sm:w-1/3 md:1/4">
        {src ? <RemarkImage src={src} /> : null}
        {fluid ? <Img fluid={fluid} /> : null}
      </div>
      <div className="w-full sm:ml-4">
        <h4 className="mt-4 sm:mt-0 text-xl">{title}</h4>
        {tags ? (
          <div className="mt-2">
              <span
                className="mt-2 inline-block mr-4 py-1 px-2 border-l-4 border-secondary text-sm"
              >
                {tags?.join(' / ')}
              </span>
          </div>
        ) : null}
        <p className="mt-4">{description}</p>
        <LinkButton marginClass="mt-4" to={to}>
          moreee
        </LinkButton>
      </div>
    </article>
  )
}
